// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"dbb81685","321":"a57975da","457":"33baa633","488":"4e126e44","551":"81d0cb7d","707":"1961d4ed","796":"554b251c","893":"08b44322"}[chunkId] + ".chunk.js";
};